<template>
  <div>
    <!-- Stats -->
    <div class="lc-stats-grid" v-if="rendered">
      <div class="lc-stat-card" v-for="stat in stats" :key="stat.label">
        <div class="lc-stat-card__icon" :style="{ background: stat.gradient }">
          <i :class="stat.icon"></i>
        </div>
        <div class="lc-stat-card__body">
          <div class="lc-stat-card__value">
            <animated-number :value="stat.value"></animated-number>
          </div>
          <div class="lc-stat-card__label">{{ stat.label }}</div>
        </div>
      </div>
    </div>

    <!-- Table Card -->
    <div class="lc-card mt-5">
      <div class="lc-card__header">
        <div class="lc-card__header-left">
          <h4 class="lc-card__title">Leads</h4>
          <span class="lc-badge">{{ total }} registos</span>
        </div>
        <div class="lc-card__header-right">
          <div class="lc-search">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              class="lc-search__input"
              type="search"
              placeholder="Nome, email, telefone..."
              v-model="searchQuery"
            />
          </div>
          <button class="lc-btn lc-btn--dark" @click="abrirExport()">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Exportar Excel
          </button>
        </div>
      </div>


      <!-- Loading -->
      <div v-if="!rendered" class="lc-loading">
        <div class="lc-loading__spinner"></div>
        <p>A carregar leads...</p>
      </div>

      <div v-else class="lc-table-wrap" :class="{ 'lc-table-wrap--a-carregar': aCarregar }">
        <table class="lc-table">
          <thead>
            <tr>
              <th v-for="col in tableColumns" :key="col.prop">
                {{ col.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in linhas" :key="row.id">
              <td class="lc-td--nome">{{ row.nome }}</td>
              <td class="lc-td--email">{{ row.email }}</td>
              <td>{{ row.telefone }}</td>
              <td>
                <span class="lc-tag lc-tag--produto">{{
                  formatProduto(row.produto)
                }}</span>
              </td>
              <td>
                <span class="lc-tag" :class="sourceClass(row.utm_source)">{{
                  row.utm_source || "—"
                }}</span>
              </td>
              <td>
                <span
                  class="lc-tag lc-tag--estado"
                  :class="estadoClass(row.estado)"
                  >{{ row.estado || "—" }}</span
                >
              </td>
              <td>
                <span
                  :class="
                    row.chatbot == 'Sim'
                      ? 'lc-dot lc-dot--green'
                      : 'lc-dot lc-dot--gray'
                  "
                ></span>
                {{ row.chatbot }}
              </td>
              <td class="lc-td--data">{{ formatData(row.dt_created) }}</td>
            </tr>
            <tr v-if="linhas.length === 0">
              <td colspan="8" class="lc-table__empty">Nenhum resultado.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="lc-card__footer">
        <p class="lc-pagination-info">
          Mostrando <strong>{{ total ? from + 1 : 0 }}</strong
          >–<strong>{{ to }}</strong> de <strong>{{ total }}</strong>
        </p>
        <n-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        />
      </div>
    </div>

    <!-- Export por datas -->
    <div class="lc-card">
      <div class="lc-card__header">
        <h4 class="lc-card__title">Exportar por intervalo de datas</h4>
      </div>
      <div class="lc-card__body">
        <div class="lc-date-export">
          <fg-input>
            <el-date-picker
              type="datetime"
              placeholder="Data inicial"
              v-model="dateTimePickerDe"
            />
          </fg-input>
          <fg-input>
            <el-date-picker
              type="datetime"
              placeholder="Data final"
              v-model="dateTimePickerAte"
            />
          </fg-input>
          <button
            v-if="dateTimePickerDe && dateTimePickerAte"
            class="lc-btn lc-btn--dark"
            @click="abrirExportDatas()"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Exportar Excel
          </button>
        </div>
      </div>
    </div>

    <exportar-modal
      :aberto="modal.aberto"
      :email-inicial="emailSessao"
      :intervalo="modal.intervalo"
      :pedir="pedirExport"
      @fechar="modal.aberto = false"
    />
  </div>
</template>

<script>
  import {
    VnudCard,
    AnimatedNumber,
    Pagination as NPagination,
    Collapse,
    CollapseItem,
  } from "@/components";
  import api from "@/api/index";
  import { ElDatePicker } from "element-plus";
  import ExportarModal from "./ExportarModal.vue";

  export default {
    components: {
      VnudCard,
      AnimatedNumber,
      NPagination,
      Collapse,
      CollapseItem,
      [ElDatePicker.name]: ElDatePicker,
      ExportarModal,
    },
    data() {
      return {
        pagination: { perPage: 25, currentPage: 1 },
        searchQuery: "",
        linhas: [],          // só a página actual, vinda do servidor
        totalServidor: 0,    // nº de leads que batem com a pesquisa
        aCarregar: false,
        pedidoActual: 0,     // descarta respostas de pedidos antigos (pesquisa rápida)
        temporizadorPesquisa: null,
        emailSessao: "",
        // modal de exportação: extra = { de, ate } quando é por intervalo
        modal: { aberto: false, intervalo: "", extra: null },
        tableColumns: [
          { prop: "nome", label: "Nome" },
          { prop: "email", label: "Email" },
          { prop: "telefone", label: "Telefone" },
          { prop: "produto", label: "Produto" },
          { prop: "utm_source", label: "Source" },
          { prop: "estado", label: "Estado" },
          { prop: "chatbot", label: "Chatbot" },
          { prop: "dt_created", label: "Data" },
        ],
        rendered: false,
        dateTimePickerDe: "",
        dateTimePickerAte: "",
        leads: {
          conversoes: 0,
          financiadosAno: 0,
          ano: new Date().getFullYear(),
          numero: 0,
          mes: 0,
          organicas: 0,
          facebook: 0,
          google: 0,
        },
      };
    },
    methods: {
      formatData(val) {
        if (!val) return "—";
        return val.slice(0, 10);
      },
      formatProduto(p) {
        const map = {
          credito_habitacao: "C. Habitação",
          credito_consolidado: "C. Consolidado",
          credito_pessoal: "C. Pessoal",
        };
        return map[p] || p || "—";
      },
      sourceClass(src) {
        if (!src) return "";
        if (src === "ORG") return "lc-tag--org";
        if (src === "fb" || src === "facebook") return "lc-tag--fb";
        if (src === "google") return "lc-tag--google";
        return "lc-tag--default";
      },
      estadoClass(estado) {
        if (!estado) return "";
        if (estado.includes("Financiado")) return "lc-tag--success";
        return "lc-tag--neutral";
      },
      sessao() {
        try {
          return JSON.parse(localStorage.getItem("lc_Dashboard_Login")) || null;
        } catch (e) {
          return null;
        }
      },
      // Uma página da tabela, pedida ao servidor (pesquisa incluída)
      async carregarPagina() {
        const sessao = this.sessao();
        if (!sessao || !sessao.cliente) return;
        const id = ++this.pedidoActual;
        this.aCarregar = true;
        const res = await api.leadsPagina({
          cliente: sessao.cliente,
          pagina: this.pagination.currentPage,
          por_pagina: this.pagination.perPage,
          pesquisa: this.searchQuery.trim(),
        });
        if (id !== this.pedidoActual) return; // chegou uma resposta mais recente entretanto
        this.aCarregar = false;
        if (!res) return;
        this.linhas = res.leads;
        this.totalServidor = res.total;
      },
      async carregarResumo() {
        const sessao = this.sessao();
        if (!sessao || !sessao.cliente) return;
        const r = await api.leadsResumo({ cliente: sessao.cliente });
        if (!r) return;
        this.leads.numero = r.total;
        this.leads.conversoes = r.financiados;
        this.leads.financiadosAno = r.financiados_ano || 0;
        this.leads.ano = r.ano || new Date().getFullYear();
        this.leads.mes = r.este_mes;
        this.leads.organicas = r.organicas;
        this.leads.facebook = r.facebook;
        this.leads.google = r.google;
      },
      // Chamado pelo modal com o email escolhido. O Excel é gerado no servidor
      // (em background) e chega por email com um link de download.
      async pedirExport(destino) {
        const sessao = this.sessao();
        if (!sessao || !sessao.cliente || !sessao.email) {
          return { resultado: "NOK", details: "Sessão sem email. Volte a entrar no dashboard." };
        }
        return api.exportarLeads(
          Object.assign(
            { cliente: sessao.cliente, email: sessao.email, destino: destino },
            this.modal.extra || {},
          ),
        );
      },
      abrirExport() {
        this.modal = { aberto: true, intervalo: "", extra: null };
      },
      abrirExportDatas() {
        if (!this.isBefore(this.dateTimePickerDe, this.dateTimePickerAte)) {
          alert("A data inicial tem de ser anterior à final.");
          return;
        }
        const fmt = (d) => new Date(d).toLocaleDateString("pt-PT");
        this.modal = {
          aberto: true,
          intervalo: "de " + fmt(this.dateTimePickerDe) + " a " + fmt(this.dateTimePickerAte),
          extra: {
            de: this.formatarDataHora(this.dateTimePickerDe),
            ate: this.formatarDataHora(this.dateTimePickerAte),
          },
        };
      },
      isBefore(a, b) {
        return new Date(a) < new Date(b);
      },
      // Data local -> "YYYY-MM-DD HH:MM:SS" (o dt_created na BD está em hora de Lisboa)
      formatarDataHora(d) {
        const x = new Date(d);
        const p = (n) => String(n).padStart(2, "0");
        return (
          x.getFullYear() + "-" + p(x.getMonth() + 1) + "-" + p(x.getDate()) +
          " " + p(x.getHours()) + ":" + p(x.getMinutes()) + ":" + p(x.getSeconds())
        );
      },
      async inicio() {
        const sessao = this.sessao();
        if (!sessao || !sessao.cliente) {
          this.rendered = true;
          return;
        }
        this.emailSessao = sessao.email || "";
        await Promise.all([this.carregarPagina(), this.carregarResumo()]);
        this.rendered = true;
      },
    },
    watch: {
      "pagination.currentPage"() {
        this.carregarPagina();
      },
      searchQuery() {
        // espera que se pare de escrever; a pesquisa volta sempre à página 1
        clearTimeout(this.temporizadorPesquisa);
        this.temporizadorPesquisa = setTimeout(() => {
          if (this.pagination.currentPage !== 1) this.pagination.currentPage = 1; // o watcher acima recarrega
          else this.carregarPagina();
        }, 350);
      },
    },
    beforeUnmount() {
      clearTimeout(this.temporizadorPesquisa);
    },
    mounted() {
      this.inicio();
    },
    computed: {
      stats() {
        return [
          {
            label: "Total Leads",
            value: this.leads.numero,
            icon: "now-ui-icons objects_spaceship",
            gradient: "linear-gradient(135deg,#4eab3e,#a9d42c)",
          },
          {
            label: "Financiados",
            value: this.leads.conversoes,
            icon: "now-ui-icons ui-1_check",
            gradient: "linear-gradient(135deg,#2980b9,#6dd5fa)",
          },
          {
            label: "Financiados " + this.leads.ano + " (escritura)",
            value: this.leads.financiadosAno,
            icon: "now-ui-icons business_money-coins",
            gradient: "linear-gradient(135deg,#032622,#4eab3e)",
          },
          {
            label: "Este Mês",
            value: this.leads.mes,
            icon: "now-ui-icons ui-1_calendar-60",
            gradient: "linear-gradient(135deg,#f39c12,#f7c948)",
          },
          {
            label: "Orgânicas",
            value: this.leads.organicas,
            icon: "now-ui-icons shopping_shop",
            gradient: "linear-gradient(135deg,#8e44ad,#c39bd3)",
          },
          {
            label: "Facebook",
            value: this.leads.facebook,
            icon: "now-ui-icons ui-2_like",
            gradient: "linear-gradient(135deg,#4267b2,#6d88c9)",
          },
          {
            label: "Google",
            value: this.leads.google,
            icon: "now-ui-icons ui-1_zoom-bold",
            gradient: "linear-gradient(135deg,#ea4335,#f4a261)",
          },
        ];
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
      to() {
        return Math.min(this.from + this.linhas.length, this.total);
      },
      total() {
        return this.totalServidor;
      },
    },
  };
</script>

<style scoped>
  .lc-table-wrap--a-carregar {
    opacity: 0.55;
    transition: opacity 0.15s;
  }
  /* Stats */
  .lc-stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 24px;
  }
  @media (max-width: 1200px) {
    .lc-stats-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  @media (max-width: 768px) {
    .lc-stats-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .lc-stat-card {
    background: #fff;
    border-radius: 14px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    transition: box-shadow 0.2s, transform 0.2s;
  }
  .lc-stat-card:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.09);
    transform: translateY(-2px);
  }
  .lc-stat-card__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 20px;
    flex-shrink: 0;
  }
  .lc-stat-card__value {
    font-size: 26px;
    font-weight: 700;
    color: #111318;
    line-height: 1;
  }
  .lc-stat-card__label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #9ca3af;
    margin-top: 4px;
  }

  /* Card */
  .lc-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    margin-bottom: 24px;
    overflow: hidden;
  }
  .lc-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    padding: 18px 24px;
    border-bottom: 1px solid #f0f0f0;
  }
  .lc-card__header-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .lc-card__header-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
  .lc-card__title {
    font-size: 14px;
    font-weight: 700;
    color: #111318;
    margin: 0;
  }
  .lc-card__body {
    padding: 20px 24px;
  }
  .lc-card__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px 24px;
    border-top: 1px solid #f0f0f0;
  }

  /* Badge */
  .lc-badge {
    background: rgba(78, 171, 62, 0.1);
    color: #357a28;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 20px;
    letter-spacing: 0.04em;
  }

  /* Search */
  .lc-search {
    position: relative;
    display: flex;
    align-items: center;
  }
  .lc-search svg {
    position: absolute;
    left: 10px;
    color: #9ca3af;
    pointer-events: none;
  }
  .lc-search__input {
    padding: 8px 12px 8px 32px;
    border: 1.5px solid #e5e7eb;
    border-radius: 8px;
    font-size: 13px;
    color: #111318;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
    width: 240px;
  }
  .lc-search__input:focus {
    border-color: #4eab3e;
    box-shadow: 0 0 0 3px rgba(78, 171, 62, 0.1);
  }

  /* Button */
  .lc-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
  }
  .lc-btn--dark {
    background: #111318;
    color: #fff;
  }
  .lc-btn--dark:hover {
    background: #2d3139;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  /* Table */
  .lc-table-wrap {
    overflow-x: auto;
  }
  .lc-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 13px;
  }
  .lc-table thead th {
    padding: 11px 16px;
    background: #f8f9fb;
    color: #9ca3af;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
    text-align: left;
  }
  .lc-table tbody td {
    padding: 11px 16px;
    border-bottom: 1px solid #f3f4f6;
    color: #3d4148;
    vertical-align: middle;
  }
  .lc-table tbody tr:last-child td {
    border-bottom: none;
  }
  .lc-table tbody tr:hover td {
    background: #f8fdf7;
  }
  .lc-td--email {
    color: #6b7280;
    font-size: 12px;
  }
  .lc-td--data {
    color: #9ca3af;
    font-size: 12px;
    white-space: nowrap;
  }
  .lc-td--nome {
    font-weight: 500;
  }
  .lc-table__empty {
    text-align: center;
    color: #9ca3af;
    padding: 40px !important;
  }

  /* Tags */
  .lc-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    background: #f3f4f6;
    color: #6b7280;
  }
  .lc-tag--produto {
    background: rgba(52, 152, 219, 0.1);
    color: #2980b9;
  }
  .lc-tag--org {
    background: rgba(78, 171, 62, 0.1);
    color: #357a28;
  }
  .lc-tag--fb {
    background: rgba(66, 103, 178, 0.1);
    color: #4267b2;
  }
  .lc-tag--google {
    background: rgba(234, 67, 53, 0.1);
    color: #ea4335;
  }
  .lc-tag--default {
    background: #f3f4f6;
    color: #6b7280;
  }
  .lc-tag--success {
    background: rgba(78, 171, 62, 0.1);
    color: #357a28;
  }
  .lc-tag--neutral {
    background: #f3f4f6;
    color: #6b7280;
  }

  /* Dot */
  .lc-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .lc-dot--green {
    background: #4eab3e;
  }
  .lc-dot--gray {
    background: #d1d5db;
  }

  /* Pagination */
  .lc-pagination-info {
    font-size: 13px;
    color: #9ca3af;
    margin: 0;
  }

  /* Loading */
  .lc-loading {
    text-align: center;
    padding: 60px;
    color: #9ca3af;
  }
  .lc-loading__spinner {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 3px solid #e5e7eb;
    border-top-color: #4eab3e;
    animation: lc-spin 0.7s linear infinite;
    margin: 0 auto 12px;
  }
  @keyframes lc-spin {
    to {
      transform: rotate(360deg);
    }
  }

  /* Date export */
  .lc-date-export {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }
  .lc-stats-grid {
    margin-top: 2%;
  }
</style>
